import React, { useEffect, useState } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { connect } from "react-redux";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import {
  editParticipantReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./EditParticipant.store";
import EditParticipant from "../../library/EditParticipant/EditParticipant";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";

export const SmartEditParticipant = (props) => {
  const {
    fetchSites,
    sites,
    studyId,
    chosenSite,
    fetchParticipantDetails,
    participant,
    participantDetails,
    updateParticipant,
    resetParticipantDetails,
    onUpdate,
  } = props;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sites.length === 0) {
      fetchSites(studyId);
    }
  }, [fetchSites, sites.length, studyId]);

  useEffect(() => {
    if (participant) {
      fetchParticipantDetails(participant.participantId).catch((errorMessage) =>
        sendNotification(errorMessage, ToastType.ERROR)
      );
    }
  }, [participant, fetchParticipantDetails]);

  useEffect(() => {
    return () => resetParticipantDetails();
  }, [resetParticipantDetails]);

  const onSubmit = (formData) => {
    setLoading(true);

    updateParticipant(formData)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        onUpdate();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {!participantDetails || !participant ? (
        <LoadingSpinner />
      ) : (
        <EditParticipant
          {...{ onSubmit }}
          {...{ sites }}
          {...{ chosenSite }}
          {...{ participantDetails }}
          {...{ participant }}
          {...{ studyId }}
          {...{ loading }}
        />
      )}
    </>
  );
};

export default dynamic(
  "editParticipantReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(editParticipantReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartEditParticipant));
